/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutAction } from '../../Redux/actions/authActions';
import styled from 'styled-components';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { SERVICES } from '../Services';
import fetchData from '../FetchData';

const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: cenetr;
  min-width: max-content;
  @media (max-width: 767px) {
    align-items: flex-start;
    justify-content: flex-start;
    width: -webkit-fill-available;
    margin-bottom: 10px;
    margin-top: 10px;
  }
`;

const Logoutbtn = styled.button`
  border: none;
  background-color: #53a8a0;
  color: white;
  cursor: pointer;
`;

const UserIcon = styled.span`
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

const UserName = styled.span`
  margin-right: 15px;
  color: white;
`;

const Dropdown = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownContent = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #53a8a0;
  min-width: 72px;
  padding: 8px;
  border-radius: 5px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
`;

const DropdownButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;

const Logout = () => {
  const dispatch = useDispatch();
  const memberId = useSelector((state) => state.member.memberId);
  const [showDropdown, setShowDropdown] = useState(false);
  const [userData, setUserData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const fetchUserData = useCallback(async () => {
    const url = SERVICES.MEMBER_DETAILS(memberId);
    await fetchData(url, setUserData, dispatch, setIsLoading);
  }, [memberId, dispatch]);
  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  const handleLogout = () => {
    dispatch(logoutAction());
  };

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };

  return (
    <MainContainer>
      <UserIcon>
        <AccountCircleOutlinedIcon />
      </UserIcon>
      <UserName>{userData.fullName}</UserName>
      <Dropdown>
        <DropdownButton onClick={handleDropdownToggle}>
          <KeyboardArrowDownIcon />
        </DropdownButton>
        {showDropdown && (
          <DropdownContent>
            <Logoutbtn onClick={handleLogout}>LOG OUT</Logoutbtn>
          </DropdownContent>
        )}
      </Dropdown>
    </MainContainer>
  );
};

export default Logout;
